import { createBrowserRouter, Navigate } from "react-router-dom";
import WorkspacePage from "./pages/WorkspacePage";
import TasksPage from "./pages/TasksPage";
import TaskNewPage from "./pages/TaskNewPage";
import TaskDetailPage from "./pages/TaskDetailPage";
import ReviewPage from "./pages/ReviewPage";
import GenerationProgressPage from "./pages/GenerationProgressPage";
import ProgressPage from "./pages/ProgressPage";
import ContextReviewPage from "./pages/ContextReviewPage";
import ConflictsPage from "./pages/ConflictsPage";
import ValidatorsPage from "./pages/ValidatorsPage";
import SettingsPage from "./pages/SettingsPage";
import InboxPage from "./pages/InboxPage";
import ErrorPage from "./pages/ErrorPage";
import { AppLayout } from "./components/AppLayout";
import ProjectsPage from "./pages/ProjectsPage";
import MobileAuthPage from "./pages/MobileAuthPage";
import DevSessionPage from "./pages/DevSessionPage";
import TestsPage from "./pages/TestsPage";
import ContextFetchTestPage from "./pages/ContextFetchTestPage";
import ProxyPage from "./pages/ProxyPage";
import { AuthGuard } from "./auth/AuthGuard";
import UsageStatsPage from '@/pages/UsageStatsPage';
import CircularDependencyPage from "./pages/CircularDependencyPage";
import { AppDataLoader } from './components/AppDataLoader';

export const router = createBrowserRouter([
  {
    path: "/pages/onboarding/mobile-auth",
    element: <MobileAuthPage />,
  },
  {
    path: "/pages/error/",
    element: <ErrorPage />,
  },
  {
    path: "/",
    element: <AuthGuard><AppDataLoader><AppLayout /></AppDataLoader></AuthGuard>,
    children: [
      {
        index: true,
        element: <Navigate to="/pages/workspace/" replace />,
      },
      {
        path: "pages/workspace/",
        element: <WorkspacePage />,
      },
      {
        path: "pages/projects/",
        element: <ProjectsPage />,
      },
      {
        path: "pages/tasks/",
        element: <TasksPage />,
      },
      {
        path: "pages/task-new/",
        element: <TaskNewPage />,
      },
      {
        path: "pages/task-detail/:id",
        element: <TaskDetailPage />,
      },
      {
        path: "pages/review/",
        element: <ReviewPage />,
      },
      {
        path: "pages/generation-progress/",
        element: <GenerationProgressPage />,
      },
      {
        path: "pages/progress/",
        element: <ProgressPage />,
      },
      {
        path: "pages/context-review/",
        element: <ContextReviewPage />,
      },
      {
        path: "pages/conflicts/:sessionId",
        element: <ConflictsPage />,
      },
      {
        path: "pages/validators/",
        element: <ValidatorsPage />,
      },
      {
        path: "pages/settings/",
        element: <SettingsPage />,
      },
      {
        path: "pages/inbox/",
        element: <InboxPage />,
      },
      {
        path: "pages/dev-session/",
        element: <DevSessionPage />,
      },
      {
        path: "pages/tests/",
        element: <TestsPage />,
      },
      {
        path: "pages/context-fetch-test/",
        element: <ContextFetchTestPage />,
      },
      {
        path: "pages/proxy/",
        element: <ProxyPage />,
      },
      { 
        path: '/pages/usage-stats',
        element: <UsageStatsPage />,
      },
      {
        path: "pages/circular-dependencies/",
        element: <CircularDependencyPage />,
      },
    ],
  },
]);